import React from "react";
import styled from "styled-components";

function Section2() {
  return (
    <Container>
      <Wrap>
        <SubWrapper>
          <Left>
            <Title>What is Akira?</Title>
            <Description>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer took a galley
                of type and scrambled it to make a type specimen book. It has
                survived not only five centuries, but also the leap into
                electronic typesetting, remaining essentially unchanged. It was
                popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop
                publishing software like Aldus PageMaker including versions of
                Lorem Ipsum
              </p>
            </Description>
          </Left>
          <Right>
            <img src="assests/what.png" alt="" />
          </Right>
        </SubWrapper>
      </Wrap>
    </Container>
  );
}

export default Section2;

const Container = styled.section`
  min-height: 10vh;
  background: #000;
  // min-width: 100vw;
  padding-top: 80px;
  @media (max-width: 1024px) {
    padding-top: 0px;
  }
`;

const Wrap = styled.div`
  margin: 64px 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 1024px) {
    margin: 64px 32px;
  }
`;

const SubWrapper = styled.div`
  max-width: 100%;
  width: 100%;
  min-width: 200px;
  display: flex;
  justify-content: space-evenly;
  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

const Left = styled.div``;

const Title = styled.div`
  font-family: Stranger;
  font-style: normal;
  font-weight: 500;
  font-size: 80px;
  color: #cf152d;
  @media (max-width: 1100px) {
    font-size: 80px;
  }
`;

const Description = styled.div`
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 300;
  line-height: 27px;
  letter-spacing: 0em;

  text-align: justified;
  color: #ffffff;
  max-width: 610px;
  width: 100%;
  min-width: 200px;
  @media (max-width: 1100px) {
    font-size: 14px;
  }
`;

const Right = styled.div`
  img {
    width: 550px;
    height: 100%;
  }
  @media (max-width: 1100px) {
    img {
      max-width: 410px;
      max-height: auto;
      width: 100%;
      height: auto;
      min-width: 240px;
      min-height: 240px;
    }
  }
  @media (max-width: 1024px) {
    margin-top: 64px;
  }
`;
